const initialState = {
  user: JSON.parse(localStorage.getItem('user')) || {} ,// {login: null, client: {slug: null}, avatar: {thumb: { url: ''} } },
  logIn: localStorage.getItem('jwt') || null,
  client: null,
  consents: []
}

const userReducer = (state = initialState, action) => {
  switch(action.type){
    case 'SAVE_USER':
      return {
        ...state,
        user: action.payload
      }
    case 'SAVE_LOGIN':
      return{
        ...state,
        logIn: action.payload
      }
    case 'SAVE_CLIENT':
      return {
        ...state,
        client: action.payload
      }
    case 'SAVE_CONSENTS':
      return {
        ...state,
        consents: action.payload
      }
    default:
      return state;
  }
}
export default userReducer;